package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class EventTeamHistogram(
    val years: List<Int>,
    val event: String,
    val name: String,
    val numMatches: Int,
    val histogram: List<Float>,
)
